import type { RemoteClient } from "../remote/remote-client"
import type { RemoteFakeRegistrar } from "../remote/remote-fakes"
import type { Presenter } from "../presentation/presenter"
import type { Localization } from "../localization/localization"
import type { ApplicationTelemetry } from "../telemetry/telemetry"
import type { Messenger } from "../messaging/messenger"
import type { DataInvalidation, DataInvalidationRegistrar } from "../data/data-invalidation"

export interface ApplicationScope {
  readonly id: string | null
  readonly parent: ApplicationScope | null
  readonly presenter: Presenter
  readonly remote: RemoteClient
  readonly localization: Localization
  readonly telemetry: ApplicationTelemetry
  readonly messenger: Messenger
  readonly dataInvalidation: DataInvalidation
}

export interface ApplicationPluginInitializationContext {
  readonly scope: ApplicationScope
  readonly presenter: Presenter
  readonly remoteFakes: RemoteFakeRegistrar
  /** Plugin-lifetime event-to-data invalidation bindings. */
  readonly dataInvalidation: DataInvalidationRegistrar
}
